export default __webpack_public_path__ + "static/media/template6.8e289b5f.jpg";